//German
export default {
    homeScreen : {
        startConversation: 'Konversation starten',
        newConversationButton: 'Hast Du Fragen?',
        newMessageButton: '+ Neue Nachricht',
        allTopics: 'Alle Themen',
        allChatsButton: 'Alle ansehen',
        poweredBy: 'Unterstützt von Richpanel',
        reOpenConversation: 'Konversation erneut eröffnen',
        recentConversations: 'Letzte Konversationen',
        startAChat: 'Starte eine Konversation ',
        noRecentConversations: 'Keine aktuelle Konversation',
        noRecentOrders: 'Keine aktuellen Bestellungen', 
        haveAQuestion: "Haben Sie eine Frage oder möchten Sie einfach nur 'Hallo' sagen? Wir würden gerne von Ihnen hören.",
        conversationClosed: `Dieses Gespräch wurde beendet. Wenn Sie Fragen zu diesem Problem haben, öffnen Sie diese Konversation erneut.`,
        retry: 'Wiederholen',
        errorOccured: 'Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten.',
        successMessage: 'Wir haben ihre Anfrage erhalten. Unser Team wird sich in Kürze per E-Mail bei Ihnen melden',
        loadingMessage: 'Warten Sie mal. Wir senden Ihre Anfrage.',
        goHome: 'NACH HAUSE GEHEN',
        sendUsMessage: 'Schick uns eine Nachricht',
        endChat: 'ENDE DES GESPRÄCHS',
        goto: 'Gehe zu',
    },
    orderStatuses: {
        'completed': 'Abgeschlossen',
        'pending': 'Ausstehend',
        'on hold': 'In der Warteschleife',
        'processing': 'In Bearbeitung',
        'cancelled': 'Abgebrochen',
        'fulfilled': 'Ausgeführt',
        'confirmed': 'Bestätigt',
    },

    loginScreen: {
        title: 'Melden Sie sich beim helpcenter an',
        titleForOrdersScreenForward: 'Melden Sie sich an, um Bestellungen anzuzeigen',
        userIdFieldTitle: "Geben Sie Ihr Telefon oder Ihre E-Mail-Adresse ein, um Unterstützung bei der Bestellung zu erhalten",
        userIdFieldPlaceHolder: "Geben Sie die Telefon- / E-Mail-Adresse ein",
        sendCode: "EINGEBEN",
        enterCode: 'Geben Sie den Code ein, den wir gesendet haben',
        enterTheCode: 'Gib den code ein',
        notYourUserId: 'Nicht dein {userIdType}?',
        userIdTypes: {
            'phone': 'nummer',
            'email': 'email',
        },
        change: 'Veränderung',
        notReceivedCode: "Wenn Sie den Code nicht erhalten haben?",
        resendCode: 'Erneut senden',
        in: "in",
        verifyCode: 'ÜBERPRÜFEN',
        logout: 'Ausloggen',
        orderNumberFieldTitle: 'Geben Sie die Bestellnummer für die Bestellunterstützung ein',
        orderNumberFieldPlaceholder: 'Bestellnummer eingeben Bsp.: 1234',
        zipcodeFieldTitle: 'Versand Postleitzahl',
        zipcodeFieldPlaceholder: 'Geben Sie die Postleitzahl des Versands ein',
        emailFieldTitle: 'E-Mail',
        emailFieldPlaceholder: 'Email eingeben',
    },

    orderList : {
        reorder: 'NACHKAUFEN',
        getHelp: 'HILFE ERHALTEN',
        startNewConversation: '+ Neue Nachricht',
        viewPreviousOrder:'ALLE BESTELLUNGEN ANSEHEN',
        seeAll: 'Alle ansehen',
        viewMoreOrders: 'MEHR BESTELLUNGEN ANSEHEN',
        viewOrderStatus: 'STATS DER BESTELLUNG ANSEHEN',
        chatWithUs: 'SPRECHE MIT UNS',
        issueWithPreviousOrder:'HILFE BEI DER LETZTEN BESTELLUNG' ,
        orderLabel: 'Bestellung',
        help: 'HILFE',
        lastOrder: 'Letzte Bestellungen',
        selectRelevantItems: 'Wichtige Artikel auswählen',
        selectItemsErrorMsg: 'Bitte wählen Sie Elemente aus, um fortzufahren',
        selectAll: 'Alle auswählen',
        selectQuantity: 'Wie viele Artikel?',
        helpWithThisOrder: 'Hilfe bei deiner Bestellung',
        yourOrders: 'Deine bestellungen',
        view: 'ANSEHEN',
        track: 'NACHVERFOLGEN',
        addressTitle: 'Bestellübersicht',
        billingAddressTitle: 'RECHNUNGSADRESSE',
        shippingAddressTitle: 'LIEFERANSCHRIFT',
        receiptTitle: 'Stk.',
        itemTotal: 'Gesamtzahl der Artikel',
        taxes: 'Steuern',
        discounts: 'Rabatte', 
        giftCard: 'Gift Card', 
        deliveryCharges: 'Lieferkosten',
        total: 'Insgesamt',
        loginToViewOrders: 'Bestehender Kunde?',
        loginSuggestion: "Holen Sie sich beschleunigte Hilfe und bestellen Sie Support",
        trackingOrderLabel: 'Bestellung verfolgen',
        shipmentDescription: "Kehren Sie zu dieser Seite zurück, um Informationen zu Ihrem Versandstatus zu erhalten",
        free: "kostenlos",
        selectedItems: "Ausgewählte Gegenstände",
        items: "Artikel",
        "orderSearchPlaceholder": 'Filtern nach Bestellnummer',
        "noOrderFound": 'Keine passenden Bestellungen {orderId}',
    },
    chatListScreen: {
        header: 'Deine Konversationen',
    },
    sentences: {
        "IN_A_DAY" : "Das Team antwortet i.d.R. innerhalb eines Tages.",
        "IN_FEW_MINUTES": "Das Team antwortet i.d.R. innerhalb einiger Minuten.",
        "IN_FEW_HOURS": "Das Team antwortet i.d.R. innerhalb einiger Stunden.",
        "AS_SOON_AS_THEY_CAN": "Das Team antwortet Ihnen schnellstmöglich.",
        "BACK_ON": "Zurück auf",
        "BACK_IN": "Zurück in",
        "HOURS": "Stunden",
        "MINUTES": 'Minuten',
        provideBelowDetails: "Bitte geben Sie die folgenden Details an",
    },
    inputFields: {
        submitted: 'Gesendet'
    },
    inputPropDisplayNames: {
        "email": "E-Mail",
        "phone": "Telefonnummer",
        "Phone": "Telefonnummer",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "uid": "Nutzer-ID",
        "campaign": "UTM Campaign", 
        "medium": "UTM Medium", 
        "googleplus": "Google plus", 
        "shippingPhone": "Telefeonnummer zur Lieferung",
        "source": "UTM Source", 
        "lastOrderAt": "Letzte Bestellzeit",
        "firstOrderAt": "Erste Bestellzeit",
        "visits": "Sitzungen",
        "facebook": "Facebook", 
        "twitter": "Twitter", 
        "updatedAt": "Zuletzt gesehen",
        "createdAt": "Zuerst gesehen",
        "linkedin": "Linkedin", 
        "instagram": "Instagram", 
        "pinterest": "Pinterest",  
        "tumblr": "Tumblr", 
        "billingEmail": "E-Mail zur Rechnung",
        "billingPhone": "Tel. zur Rechnung",
        "shippingEmail": "E-Mail zur Lieferung",
        "state": "Bundesland",
        "city": "Stadt",
        "country": "Land",
        "deviceType": "Geräteart",
        "browserName": "Browsername",
        "osName": "OS Name",
        "platform": "Plattform",
        "ltv": "CLV", 
        "ordersCount": "Orders Count", 
        "name": "Name", 
        "RichpanelPredictedCLV": "Predicted CLV", 
        "RichpanelAliveProbability": "Kaufwahrscheinlichkeit",
        "RichpanelNextOrderDate": "Nächstes Bestelldatum",
        "RichpanelPredictedOrderCount": "Voraussichtliche Bestellsanzahl",
        "aov": "AOV", 
        "WebsiteURL":"Website-URL"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Sind Sie bereits Kunde?',
        YES_EXISITING_CUSTOMER: "Ja, ich bin bereits Kunde.",
        NO_EXISITING_CUSTOMER: "Nein, Ich bin noch kein Kunde.",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Wie darf dich unser Team kontaktieren?",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Du wirst über eine Antwort hier und via E-Mail ({email}) benachrichtigt.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Du wirst hier über Antworten benachrichtigt.",
        LEAVE_YOUR_MESSAGE: "Hinterlasse uns eine Nachricht.",
        TEAM_WILL_BE_BACK_IN:"Das Team wird in {hours} wieder da sein.",
        TEAM_WILL_BE_BACK_ON:"Das Team ist bald erreichbar: {availableAt}",
        FEW_MORE_DETAILS: "Vielen Dank! Ein paar weitere Details helfen dabei, dir den richtigen Kontakt zuzuweisen:",
    },
    initialForm: {
        heading: 'Bitte gebe deine Angaben ein, um zu chatten',
        startChat: 'Konversation starten'
    },
    customerJourneyPreChatForm: {
        heading: 'Starte eine Konversation',
        startChat: 'Starte eine Konversation',
        proceed: 'Fortfahren',
        canWeHelpWithAnythingElse: 'Können wir bei irgendetwas anderem helfen?', 
        yes: 'Ja',
        no: 'Nein',
        noThanks: "Nein Danke",
        yesContactSupport: "Ja, Chatten Sie mit dem Support",
        contactSupport: "Wenden Sie sich an den Support",
    },
    rating: {
        askedHeader: 'Bewerte die Konversation',
        successHeader: 'Du hast diese Konversation bewertet',
        thanksMessage: "Vielen Dank für deine Meinung.",
        placeholderForRatingFeedback: "Bitte schreibe ein Feedback"
    },
    placeholders: {
        emojiSearch: 'Suche Emojis',
        typeAMessage: 'Schreibe eine Nachricht',
        searchGifs: 'Suche GIFs',
    },
    lastMessageText: {
        sentAGif: 'Sende ein GIF',
        sharedFile: 'Eine Datei freigegeben',
        askedForQualificationDetails: 'Nach Qualifikationsdetails gefragt.',
        askedForRating: 'Nach Bewertung gefragt',
        askedForFeedback: 'Nach Feedback gefragt',
        sharedOrderSummary: "Zusammenfassung der Bestellung"
    },
    greetingAnimation: {
        weAreOnline: 'Wir sind online',
        askUsAnything: 'Fragen Sie uns etwas',
        chatWithUs: 'Spreche mit uns'
    }
}